import { createReducer } from '../../store.model';

import { ActionType } from './main.action';
import { defaultState, MainState } from './main.state';
import { Reload, ReloadResult } from './state/reload.action';
import { reloadReducer, reloadResultReducer } from './state/reload.reducer';
import { Reset } from './state/reset.action';
import { resetReducer } from './state/reset.reducer';
import { SelectTemplateVersion } from './state/select-template-version.action';
import { selectTemplateVersionReducer } from './state/select-template-version.reducer';
import { SelectUser } from './state/select-user.action';
import { selectUserReducer } from './state/select-user.reducer';

const { reducer, builder } = createReducer<ActionType, MainState>(
    defaultState(),
);

builder
    .add<Reload>(ActionType.EVAL_MAIN__RELOAD, reloadReducer)
    .add<ReloadResult>(
        ActionType.EVAL_MAIN__RELOAD_RESULT,
        reloadResultReducer,
    );

builder.add<SelectUser>(ActionType.EVAL_MAIN__SELECT_USER, selectUserReducer);

builder.add<SelectTemplateVersion>(
    ActionType.EVAL_MAIN__SELECT_TEMPLATE_VERSION,
    selectTemplateVersionReducer,
);

builder.add<Reset>(ActionType.EVAL_MAIN__RESET, resetReducer);

export const mainReducer = reducer;
